export default "__VITE_ASSET__TKB7jNEj__"